(ns practitest.frontend.project-fields-settings.subs
  (:require
   [practitest.frontend.project-fields-settings.events :as pf-events]
   [re-frame.core :as re-frame]))

(def custom-field-form-id :project-fields-form)

(re-frame/reg-sub
  :project-fields-settings/init-complete?
  (fn [db _]
    (:project-fields-init-complete? db)))

(re-frame/reg-sub
  :project-fields-settings/seeded-custom-field
  (fn [db _]
    (:custom-field db)))

(re-frame/reg-sub
  :project-fields-settings/seeded-system-field
  (fn [db _]
    (:system-field db)))

(re-frame/reg-sub
  ::custom-fields-form-data
  (fn [db _]
    (get-in db [:form-states2 custom-field-form-id :fields])))

(re-frame/reg-sub
 :project-fields-settings/form-loading?
 (fn [db _]
   (get-in db [:form-states2 custom-field-form-id :loading?] false)))

(re-frame/reg-sub
 ::custom-field-id
 (fn [db _]
   (get-in db [:current-route :path-params :custom-field-id])))

(re-frame/reg-sub
 ::custom-fields-modal-data
 (fn [db _]
   (get-in db [:form-states2 custom-field-form-id :modal-data])))

(re-frame/reg-sub
 ::custom-fields-show-modal
 (fn [db _]
   (get-in db [:form-states2 custom-field-form-id :modal-data :show])))

(re-frame/reg-sub
 ::custom-fields-linkage-modal-data
 (fn [db _]
   (get-in db [:form-states2 custom-field-form-id :linkage-modal-data])))

(re-frame/reg-sub
 ::custom-fields-show-linkage-modal
 (fn [db _]
   (get-in db [:form-states2 custom-field-form-id :linkage-modal-data :show])))

(re-frame/reg-sub
 :project-fields-settings/list-field-names
 (fn [db _]
   (let [list-type #{"list" "linkedlist"}]
     (->> (vals (:project-custom-fields db))
          (filter #(and (:custom? %) (list-type (:type %))))
          (mapv :label)))))

(re-frame/reg-sub
 :project-fields-settings/list-items
 (fn [db [_ list-name]]
   (let [{:keys [values type]} (first (filter #(and (:custom? %) (= list-name (:label %))) (vals (:project-custom-fields db))))]
     (if (= type "linkedlist")
       (vec (distinct (apply concat (vals values))))
       values))))

(re-frame/reg-sub
 ::rename-modal-data
 (fn [db _]
   (get-in db [:form-states2 custom-field-form-id :rename-modal])))

(re-frame/reg-sub
 ::rename-saving?
 (fn [db _]
   (contains? (:progress db) ::pf-events/rename-value-progress)))

(re-frame/reg-sub
 ::possible-value-action-in-progress?
 (fn [db _]
   (boolean (some (:progress db) [:check-possible-values-for-deleting
                                   :delete-possible-values
                                   ::pf-events/rename-value-progress]))))

(re-frame/reg-sub
 ::sf-form-data
 (fn [db _]
   (get-in db [:form-states2 pf-events/sf-form-id :fields])))

(re-frame/reg-sub
 :project-fields-settings/sf-form-loading?
 (fn [db _]
   (get-in db [:form-states2 pf-events/sf-form-id :loading?] false)))

(re-frame/reg-sub
 ::sf-modal-data
 (fn [db _]
   (get-in db [:form-states2 pf-events/sf-form-id :modal-data])))

(re-frame/reg-sub
 ::source-list-options
 (fn [db _]
   (or (:source-list-options db) [])))

(re-frame/reg-sub
 ::source-list-confirm
 (fn [db _]
   (get-in db [:form-states2 custom-field-form-id :source-list-confirm])))

(re-frame/reg-sub
 ::sf-rename-modal-data
 (fn [db _]
   (get-in db [:form-states2 pf-events/sf-form-id :rename-modal])))

(re-frame/reg-sub
 ::sf-action-in-progress?
 (fn [db _]
   (boolean (some (:progress db) [:sf-check-possible-values-for-deleting]))))
